

export const CloseButtonModal = ({toggleModal, btnCloseClass}) => {
    return (
        <div className={`close-button-container ${btnCloseClass}`}>
                <button type="button" className="btn-close btn-close-class" data-bs-dismiss="modal"
                    aria-label="Close" onClick={toggleModal}></button>
            </div>
    )
}
